import { Observable } from 'rxjs'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Gate } from './gate'
import { GateSerializer } from './gate.serializer'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { buildHttpParams } from 'src/app/shared/query-utils'

@Injectable()
export class GateService extends ResourceService<Gate> {
  constructor(
    private http: HttpClient,
    private gateSerializer: GateSerializer
  ) {
    super(http, `${environment.backendApiUrl}/gates`, gateSerializer)
  }
}
